// extracted by mini-css-extract-plugin
module.exports = {"root":"DJNkj7SV"};